module.exports = __webpack_public_path__ + "static/img/a088.a934572.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/banner/s/a088.jpg
// module id = nbN3
// module chunks = 0